export const FileUpload = {
    data() {
        return {
          fileUploadErrorMessage:''
        };
    },
    methods: {
        handleFileUpload(event){
            this.form.fileupload = [];
            const files = event.target.files;
            for (let i = 0; i < files.length; i++) {
              let file = files[i];
          
              if (file.size > this.fileUploadSize * 1024 * 1024) {
                this.fileUploadErrorMessage = this.___("File-Upload|File upload size|content");
              } else {
                this.fileUploadErrorMessage = '';
                this.form.fileupload.push(file);
              }
            }
        },
        handleSingleFileUpload(event){
          this.form.fileupload = null;
          let file = event.target.files[0];
          if (file && file.size > this.fileUploadSize * 1024 * 1024) {
            this.fileUploadErrorMessage = this.___("File-Upload|File upload size|content");
          } else {
            this.fileUploadErrorMessage = '';
            this.form.fileupload = file;
          }
        }
    }
};
